

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHomeMainData } from './homeApi';
import CarouselSlider from '../../Shared/CarouselSlider/CarouselSlider';
import IntroSection from './IntroSection';
import SecondSection from './SecondSection';
import CurebaySolutions from './CurebaySolutions';
import ThirdSection from '../../Shared/ThirdSection/ThirdSection';
import CheckHealthSteps from '../../Shared/CheckHealthSteps/CheckHealthSteps';
import ConcernsSection from '../../Shared/ConcernsSection/ConcernsSection';
import CTABanner from './CTABanner';
import StatsSection from './StatsSection';

const ROUTE_MAP = {
  caresathi: '/caresathi',
  labinsights: '/labinsight',
  skincare: '/skincare',
  oralcare: '/oralcare',
  smartvital: '/smartvital',
  symptomchecker: '/symptomchecker',
  lungscare: '/lungscare',
  smartreport: '/smartreport',
};

const HomePage = () => {
  const [attrs, setAttrs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const thirdSectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleMouseMove = (e) => setMousePosition({ x: e.clientX, y: e.clientY });
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleCardClick = (item) => {
    const subheading = (item?.subheading || '').toLowerCase();
    const path = ROUTE_MAP[subheading];

    if (path) {
      window.location.href = `https://patients-stage-new.curebay.in${path}`;
    } else {
      console.warn('No route found for:', subheading);
    }
  };

  const handleSecondButton = () => {
    navigate('/aireports', { state: { scrollTo: 'ai-reports-section' } });
  };

  const handleFirstButtonClick = () => {
    thirdSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    let isMounted = true;
    getHomeMainData()
      .then(res => {
        if (!isMounted) return;
        setAttrs(res.data?.data?.[0]?.attributes || {});
      })
      .catch(err => { if (!isMounted) return; setError(err); })
      .finally(() => { if (isMounted) setLoading(false); });
    return () => { isMounted = false; };
  }, []);

  if (loading) return <div className="p-8 text-center">Loading…</div>;
  if (error) return <div className="p-8 text-center text-red-600">Error loading data.</div>;
  if (!attrs) return <div className="p-8 text-center">No data</div>;

  const firstcompItem = attrs.first?.[0] || {};
  const firstSectionItems = [
    {
      heading: firstcompItem.heading || '',
      subheading: firstcompItem.subheading || '',
      description: firstcompItem.description || '',
      button1: firstcompItem.button1 || '',
      button2: firstcompItem.button2 || '',
      onButton2Click: handleSecondButton,
      image: firstcompItem.image || '',
      gif: firstcompItem.gif || '',
      image1: firstcompItem.image1 || '',
    },
  ];

  const outcomes = attrs.outcomes || [];
  // CureBay Solutions content lives in the 4th "third" entry in the CMS;
  // if that entry is missing or has no cards, fall back to the 1st entry
  const fourthThird = attrs.third?.[3];
  const thirdSection = (fourthThird?.thirdsub?.length ? fourthThird : attrs.third?.[0]) || {};
  const fifthSection = attrs.fifth?.[0] || {};

  return (
    <>
      <section>
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-secondaryColor/8 to-transparent rounded-full blur-3xl animate-pulse" />
          <div className="absolute bottom-32 right-16 w-96 h-96 bg-gradient-to-tr from-lightBlue/10 to-transparent rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
          <div className="absolute top-1/2 left-1/4 w-48 h-48 bg-gradient-to-br from-secondaryColor/6 to-transparent rounded-full blur-2xl animate-bounce" style={{ animationDelay: '2s', animationDuration: '3s' }} />
        </div>

        <IntroSection
          items={firstSectionItems}
          onButtonClick={handleFirstButtonClick}
          onShrutiClick={() => {
            // Shruti is a separate site per environment (REACT_APP_SHRUTI_URL); fall back to CareSathi if unset
            const shrutiUrl = process.env.REACT_APP_SHRUTI_URL;
            if (shrutiUrl) window.open(shrutiUrl, '_blank', 'noopener,noreferrer');
            else handleCardClick({ subheading: 'caresathi' });
          }}
        />

        <div ref={thirdSectionRef}>
          {Object.keys(thirdSection).length > 0 && (
            <CurebaySolutions data={thirdSection} onCardClick={handleCardClick} />
          )}
        </div>

        {outcomes.length > 0 && <SecondSection outcomes={outcomes} />}

        {Object.keys(fifthSection).length > 0 && <StatsSection data={fifthSection} />}
      </section>

    </>
  );
};


export default HomePage;